<template>
  <v-col xs="12" sm="12" md="12" lg="12">
    <v-responsive width="100%" v-if="$vuetify.breakpoint.xsOnly" />
    <v-card elevation="5" rounded>
      <v-row class="mx-1 mb-1">
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field type="date" label="From date" outlined dense v-model="search.from_date">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field type="date" label="End date" outlined dense v-model="search.end_date">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2" v-if="(ROLE == 'Owner')">
          <v-select :items="branch" outlined dense label="Branch" item-text="name" item-value="id"
            v-model="search.branch"></v-select>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field label="Search" outlined dense v-model="search.search">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-btn small color="darkblue" class="white--text mx-1" @click.stop="init">Submit <v-icon
              right>mdi-magnify</v-icon></v-btn>
          <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
            <v-icon right>mdi-close-circle-multiple </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table :loading="loading" :headers="headers" :items="PettyCashs.data" class="elevation-1"
        hide-default-footer>
        <template slot="body.append">
          <tr>
            <th colspan="5"></th>
            <th style="font-size: 15px;">{{ sumField('amount') | currency("", 0, { symbolOnLeft: false, }) }}</th>
            <th></th>
          </tr>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip color="dark" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-2" color="warning" v-bind="attrs" icon small @click.stop="edit(item.id)" v-on="on">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Petty Cash</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <b>{{ item.amount | currency("", 0, { symbolOnLeft: false, }) }}</b>
        </template>
      </v-data-table>
      <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "PettyCashList",
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Petty Cash Category", value: "petty_cash_category.name" },
        { text: "Branch", value: "branch.name" },
        { text: "Customer", value: "customer.name" },
        { text: "Date", value: "date" },
        { text: "Amount", value: "amount" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      branch: [],
      disabled: false,
      loading: false,
      page: 1,
      loading_download: false,
      flag: null,
      status: [],
      search: {
        from_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        end_date: new Date().toJSON().slice(0, 10),
        search: null,
        branch_id: null,
      },
    };
  },
  methods: {
    ...mapMutations("petty_cash", ["CLEAR_STATE", "SET_PETTY_CASHS", "SET_PETTY_CASH", "SET_CURRENT_PAGE"]),
    sumField(key) {
      return this.PettyCashs.data.reduce((a, b) => a + (b[key] || 0), 0)
    },
    async init() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        from_date: this.search.from_date,
        end_date: this.search.end_date,
        branch_id: this.search.branch_id,
        search: this.search.search,
      };

      await this.$axios
        .get("/transaction/petty-cash", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.$store.commit("petty_cash/SET_PETTY_CASHS", data.petty_cashes);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch.data;
        });
    },

    async getStatus() {
      await this.$axios
        .get("/transaction/sales-order-status", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.status = data.sales_order_status;
        });
    },

    async edit(id) {
      this.loading = true;
      await this.$axios
        .get("/transaction/petty-cash/" + id, {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_PETTY_CASH(data.petty_cashes);
          this.loading = false;
          this.$router.push("/petty-cash/edit");
        })
        .catch(() => {
          this.loading = true;
        });
    },

    view(id) {
      this.$router.push("/petty-cash/view/" + id);
    },

    searching() {
      this.page = 1;
      this.init();
    },
    clear() {
      this.search = {
        status: "",
        search: "",
        branch_id: "",
        from_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        end_date: new Date().toJSON().slice(0, 10),
      };
      this.init();
    },
  },

  created() {
    this.init();
    this.getStatus();
    this.getBranch();
  },

  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.init();
    },
  },
  computed: {
    ...mapGetters("petty_cash", {
      PettyCashs: "PettyCashs",
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    currentPage: {
      get() {
        return this.PettyCashs.current_page;
      },
      set(val) {
        return this.$store.commit("petty_cash/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.PettyCashs.last_page;
      },
    },
  },
};
</script>
<style scoped>
::v-deep .v-data-table-header {
  background-color: #ebebeb59;
}

::v-deep th {
  color: #000 !important;
}
</style>